import { memo } from "react";
import { useFormContext } from "react-hook-form";

import {
  MultiImageUploader,
  MultiImageUploaderProps,
  SingleImageUploader,
  SingleImageUploaderProps,
} from "../ImageUploader";
import { MultiplePerson, MultiplePersonProps } from "../MultiplePerson";
import { FormElement } from "../enums";
import { ComplexFormSchemaComponents } from "../types";

type ComplexComponentsFactoryProps = {
  readonly component: ComplexFormSchemaComponents;
};

export const ComplexComponentFactory = memo<ComplexComponentsFactoryProps>(
  ({ component }) => {
    const { register } = useFormContext();
    const { type, ...componentProps } = component;

    switch (type) {
      case FormElement.IMAGE_UPLOADER_SINGLE:
        return (
          <SingleImageUploader
            {...(componentProps as SingleImageUploaderProps)}
          />
        );

      case FormElement.IMAGE_UPLOADER_MULTIPLE:
        return (
          <MultiImageUploader
            {...(componentProps as MultiImageUploaderProps)}
          />
        );

      case FormElement.MULTIPLE_PERSON:
        return (
          <MultiplePerson
            {...({
              ...componentProps,
              register,
            } as MultiplePersonProps)}
          />
        );

      default:
        throw new Error(
          "You have to pass proper component into form component factory"
        );
    }
  }
);
